import { configureStore } from '@reduxjs/toolkit';

import { authModalReducer } from 'authOld/slices';
import { notificationsReducer } from 'core/slices';
import { tableReducer } from 'coreOld/slices';
import { companyPartsReducer } from 'partsOld/slices';

const reducer = {
  companyParts: companyPartsReducer,
  notification: notificationsReducer,
  table: tableReducer,
  authModal: authModalReducer,
};

export const store = configureStore({
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['meta.arg', 'payload.message'],
        ignoredPaths: ['notification.notification'],
      },
    });
  },
  reducer,
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
